import { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { SnackbarColor } from '../js/types';
import useVersionCheck from '../hooks/useVersionCheck';

const VersionChecker = () => {
    const { hasNewVersion } = useVersionCheck();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!hasNewVersion) return;
        enqueueSnackbar('系統已更新，請點擊重新整理以取得最新版本', {
            variant: SnackbarColor.warning,
            persist: true,
            action: () => (
                <IconButton onClick={() => window.location.reload()}>
                    <Refresh style={{ color: '#fff' }} />
                </IconButton>
            ),
        });
    }, [hasNewVersion, enqueueSnackbar]);

    return null;
};

export default VersionChecker;
